import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1562081c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-admin" }
const _hoisted_2 = {
  key: 0,
  class: "admin-setting-group"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Privileges", -1))
const _hoisted_4 = { class: "list-unstyled" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = { class: "admin-setting-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Metadata", -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "admin-setting-group limits" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Limits", -1))
const _hoisted_11 = { class: "list-unstyled" }
const _hoisted_12 = { class: "big-value" }
const _hoisted_13 = { class: "admin-setting-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Account options", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "admin-actions" }

import { computed, ref, watch } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { LoadMode } from '@/util/AsyncData'
import { UserPrivilege, getPrivilegeDisplayName, useTokenManager } from '@/auth/TokenManager'
import { PatchChange } from '@/util/Api'
import { ShieldIcon } from '@zhuowenli/vue-feather-icons'
import { UserLimits } from '@/gp/GroupAdminModel'
import { capitalize } from '@/util/LanguageUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountAdmin',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props;



const privileges = [
  UserPrivilege.ReadAllUsers,
  UserPrivilege.ReadAllDataGroups,
  UserPrivilege.ReadAllFamilyGroups,
  UserPrivilege.ManageUsers,
  UserPrivilege.ImpersonateUser,
]

const nameConfirmedRef = ref(false)
const limitsDisabledRef = ref(false)
const busyRef = ref(false)

const userStore = useUserStore()
const tokenManager = useTokenManager()

const isSelfRef = computed(() => tokenManager.current.userId == props.userId)
const userRef = computed(() => userStore.getAsyncUser(props.userId, LoadMode.EnsureLoaded)?.data)
const limitKeysRef = computed(() => Object.keys(new UserLimits()) as (keyof UserLimits)[])
const canEditRef = computed(() => tokenManager.current.hasPrivilege(UserPrivilege.ManageUsers) && !busyRef.value)
const showImpersonateRef = computed(() => !isSelfRef.value && tokenManager.canImpersonateAnyUser())

watch(userRef, () => {
  nameConfirmedRef.value = userRef.value?.metadata?.nameConfirmed ?? false
  limitsDisabledRef.value = userRef.value?.limitsDisabled ?? false
}, { immediate: true })

watch(nameConfirmedRef, async () => {
  if (userRef.value && nameConfirmedRef.value != userRef.value.metadata?.nameConfirmed) {
    busyRef.value = true
    const change = new PatchChange('/metadata/nameConfirmed', nameConfirmedRef.value)
    await userStore.patchAsync(props.userId!, [change])
    busyRef.value = false
  }
})

watch(limitsDisabledRef, async () => {
  if (userRef.value && limitsDisabledRef.value != userRef.value?.limitsDisabled) {
    busyRef.value = true
    await userStore.setLimitsDisabledAsync(props.userId!, limitsDisabledRef.value)
    busyRef.value = false
  }
})

async function impersonateUser() {
  if (props.userId) {
    tokenManager.impersonateAsync(props.userId)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isSelfRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(privileges, (pr) => {
              return _createElementVNode("li", { key: pr }, [
                _createElementVNode("label", null, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    checked: _unref(tokenManager).current.hasPrivilege(pr),
                    disabled: ""
                  }, null, 8, _hoisted_5),
                  _createTextVNode(" " + _toDisplayString(_unref(getPrivilegeDisplayName)(pr)), 1)
                ])
              ])
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameConfirmedRef).value = $event)),
          disabled: !canEditRef.value
        }, null, 8, _hoisted_8), [
          [_vModelCheckbox, nameConfirmedRef.value]
        ]),
        _createTextVNode(" User name confirmed ")
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("ul", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitKeysRef.value, (limit) => {
          return (_openBlock(), _createElementBlock("li", { key: limit }, [
            _createTextVNode(_toDisplayString(_unref(capitalize)(limit)) + ": ", 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(userRef.value!.limits![limit]), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((limitsDisabledRef).value = $event)),
          disabled: !canEditRef.value
        }, null, 8, _hoisted_15), [
          [_vModelCheckbox, limitsDisabledRef.value]
        ]),
        _createTextVNode(" Disable account limits ")
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (showImpersonateRef.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-warning impersonate",
            onClick: impersonateUser
          }, [
            _createVNode(_unref(ShieldIcon), { size: "1.2x" }),
            _createTextVNode(" Impersonate ")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})